
import {Component, Vue} from 'vue-property-decorator';
import menu from './jsons/menu.json';
import {Alert} from "@/addons/Alert";
import {globalStore} from "@/store/globalStore";
import {GlobalService} from "@/services/GlobalService";
import {UserAuth} from "@/models/UserAuth";

@Component({
  name: 'App'
})
export default class App extends Vue {
  globalStore = globalStore();
  globalService = GlobalService.getInstance();

  menu = menu;
  drawer = true;

  get isLogin() {
    this.globalService.checkLogin();
    return this.globalStore.isLogin;
  }

  get urlYakusela() {
    return this.globalStore.urlYakusela;
  }

  get usuario(): UserAuth {
    return this.globalStore.user;
  }

  mounted() {
    if (this.isLogin) {
      this.globalService.getUsuario();
      this.globalService.getPermisos();
      this.globalService.getFecha();
    }
  }

  logout() {
    Alert.confirm("¿Seguro que quiere salir del módulo?").then(res => {
      if (res.isConfirmed) {
        this.salirDelSistema();
      }
    })
  }

  salirDelSistema() {
    this.globalService.destroyToken().then(() => {
      window.location.href = this.urlYakusela;
    })
  }

  abrirManual() {
    window.open(
        "/ManualUsuario.pdf", "_blank");
  }
}
